import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import PaymentOptions from "./PaymentOptions";

// Bottom footer: left = copyright, right = payment options
// Mobile (xs): stacked vertically; sm+ horizontal with items pinned to edges
export default function BottomFooter() {
  const year = new Date().getFullYear();
  const { t: myTranslate } = useTranslation();

  return (
    <Container
      maxWidth="xl"
      sx={{
        py: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          flexWrap: { xs: "wrap", sm: "nowrap" },
          gap: { xs: 2, sm: 0 },
        }}
      >
        <Typography
          variant="body2"
          className="notranslate"
          translate="no"
          sx={{
            color: "rgba(255, 255, 255, 0.7)",
            fontSize: "0.9rem",
            textAlign: "left",
          }}
        >
          {myTranslate("footer.copyright", { year })}
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <PaymentOptions />
        </Box>
      </Box>
    </Container>
  );
}
